import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { StudentService } from 'src/app/private/services/student.service';
import { DeleteStudentComponent } from '../../components/student/delete-student/delete-student.component';
import { BulkUpdateComponent } from "../../components/leads/bulk-update/bulk-update.component";
import { RegistrationService } from 'src/app/private/services/registration.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { HostelService } from 'src/app/private/services/hostel.service';
import { TransportService } from 'src/app/private/services/transport.service';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { UsersService } from 'src/app/private/services/users.service';

@Component({
  selector: 'app-student',
  standalone: true,
  imports: [ToolBarComponent, SharedModule, DeleteStudentComponent, BulkUpdateComponent],
  templateUrl: './student.component.html',
  styleUrl: './student.component.scss'
})
export class StudentComponent {
  selectedProducts: any[] = [];
  startDate: any = null;
  endDate: any = null;
  rows: number = 25;
  isOpenAddDialog: boolean = false;

  loading: boolean = false;
  dataSource: any[] = [];
  displayedColumns: any[] = [];
  totalRecords: number = 0;
  editLeadData: any = null;
  isDeleteStudent: boolean = false;

  filtersOptions: any[] = [];
  exportItems: any[] = [];

  isBulkUpdate: boolean = false;

  academicYears: any[] = [];
  allCourses: any[] = [];
  departments: any[] = [];
  batches: any[] = [];
  feeGroups: any[] = [];
  hostelCategories: any[] = [];
  transportCategories: any[] = [];
  scholarshipTypes: any[] = [];

  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Students',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdate = true;
          }
        },
        // {
        //   label: 'Delete Students',
        //   icon: 'pi pi-trash',
        //   styleClass: 'delete-menu-item',
        //   command: () => {
        //     // this.isBulkDeleteStudents = true;
        //   }
        // }
      ]
    }
  ];

  leadActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Student',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.router.navigate([`/main/student/${this.editLeadData?.student_id}`]);
          }
        },
        {
          label: 'Delete Student',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteStudent = true;
          }
        }
      ]
    }
  ];

  constructor(
    private localStorage: LocalStorageService,
    private api: StudentService,
    private router: Router,
    private messageService: MessageService,
    private registrationApi: RegistrationService,
    private batchService: BatchService,
    private academicYearService: AcademicYearService,
    private feeGroupService: FeeService,
    private hostelApi: HostelService,
    private transportApi: TransportService,
    private scholarshipApi: ScholarshipService,
    private userApi: UsersService
  ) { }

  openStudentProfile(rowData: any) {
    this.router.navigate([`/main/student/${rowData.student_id}`]);
  }

  ngOnInit() {
    this.setFilterOptions();
    this.setFixedColumn();
    this.setExportColumns();
    this.getAllCourses();
    this.getAllDepartments();
    this.getAllAcademicYears();
    this.getAllBatches();
    this.getAllFeeGroups();
    this.getAllHostelCategories();
    this.getAllTransportRoutes();
    this.getAllScholoarshipTypes();
  }


  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.allCourses = this.allCourses.map((course: any) => {
          course.course_id = parseInt(course.course_id);
          return course;
        }
        );
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departments = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearService.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYears = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.batchService.getAllBatches(param).subscribe({
      next: (data) => {
        this.batches = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllFeeGroups() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.feeGroupService.getAllActiveFeeGroups(param).subscribe({
      next: (res: any) => {
        this.feeGroups = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllHostelCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.hostelApi.getAllHostelCategories(param).subscribe({
      next: (data) => {
        this.hostelCategories = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllScholoarshipTypes() {

    console.log("Fetching Scholarship Types");
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.scholarshipApi.getAllScholarships(param).subscribe({
      next: (data) => {
        this.scholarshipTypes = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllTransportRoutes() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.transportApi.getAllTransports(param).subscribe({
      next: (data) => {
        this.transportCategories = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  loadStudents(event: any) {
    this.loading = true;
    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    let params = {
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId(),
      "page": page,
      "limit": size,
      "order": {
        "col": "\"student\".\"updatedAt\"",
        "dir": "DESC"
      },
      "where": {
        isArchived: false
      }
    };

    this.api.getAllStudentsWithCount(params).subscribe({
      next: (res: any) => {
        this.dataSource = res?.rows || [];
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to load students'
        });
      }
    });
  }

  setFilterOptions() {
    this.filtersOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
      { label: 'Graduated', value: 'graduated' }
    ];
  }

  setFixedColumn() {
    this.displayedColumns = [
      { field: 'student_roll_no', header: 'Student Roll No', type: 'text' },
      { field: 'student_name', header: 'Student Name', type: 'student_name' },
      { field: 'email', header: 'Email', type: 'text' },
      { field: 'phone', header: 'Phone', type: 'text' },
      { field: 'course', header: 'Course', sortable: false, type: 'course' },
      { field: 'department', header: 'Department', sortable: false, type: 'department' },
      { field: 'batch', header: 'Batch', sortable: false, type: 'batch' },
      { field: 'academic_year', header: 'Academic Year', sortable: false, type: 'academic_year' },
      { field: 'status', header: 'Status', type: 'status' },
      { field: 'createdAt', header: 'Created Date', type: 'date' },
      { field: 'actions', header: 'Actions', sortable: false, type: 'actions' }
    ];
  }

  setExportColumns() {
    this.exportItems = [
      { label: 'Excel', icon: 'pi pi-file-excel', command: () => this.export('excel') },
      { label: 'CSV', icon: 'pi pi-file', command: () => this.export('csv') }
    ];
  }

  handleSearch(searchTerm: string) {
    // Implement search functionality
    console.log('Search term:', searchTerm);
  }

  handleDateFilter(dateRange: any) {
    this.startDate = dateRange.startDate;
    this.endDate = dateRange.endDate;
    this.loadStudents({});
  }

  handleResetFilters() {
    this.startDate = null;
    this.endDate = null;
    this.loadStudents({});
  }

  export(type: string) {
    // Implement export functionality
    console.log('Export type:', type);
  }

  setLeadEditData(data: any) {
    this.editLeadData = data;
  }

  getFullName(student: any) {
    return [student?.prefix, student?.first_name, student?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  getStatusColor(status: string) {
    switch (status?.toLowerCase()) {
      case 'active':
        return '#22c55e';
      case 'inactive':
        return '#f59e0b';
      case 'graduated':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  }

  handleCallLead(student: any) {
    // Implement call functionality
    console.log('Call student:', student);
  }

  handleWhatsappLead(student: any) {
    // Implement WhatsApp functionality
    console.log('WhatsApp student:', student);
  }

  handleEmailLead(student: any) {
    // Implement email functionality
    console.log('Email student:', student);
  }

  reloadDataTable() {
    this.loadStudents({});
  }
}
